import styled, { css } from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

export interface ScInfoBtnProps {
  gray?: boolean;
}

export const ScInfoBtn = styled.div<ScInfoBtnProps>`
  cursor: pointer;
  width: 24px;
  height: 24px;

  svg {
    width: 24px;
    height: 24px;

    path {
      fill: ${({ theme }) => theme.whiteColor};
      transition: 0.3s;
    }

    @media (hover: hover) {
      &:hover {
        path {
          fill: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
        }
      }
    }

    ${({ gray }) =>
      gray &&
      css`
        path {
          fill: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
        }

        @media (hover: hover) {
          &:hover {
            path {
              fill: ${({ theme }) => theme.whiteColor};
            }
          }
        }
      `}
  }
`;
